module.exports = __webpack_public_path__ + "static/media/logo.cac87345.svg";